import React, { useContext, useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { ContextType, verificationContext } from '../context/VerificationContext'
import { Divider, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material'

import EditNoteIcon from '@mui/icons-material/EditNote';
import ErrorIcon from '@mui/icons-material/Error';
import { getSocialHistoryData } from '../../../EMR/services'
import usePopup from '../../../hooks/usePopup'
import SocialHistoryData from '../../../EMR/components/History/socialHistory/Socialhistory'

function SocialHistory() {


  const { searchData } = useContext(verificationContext) as ContextType
  const [tableData, setTableData] = useState<any>()
  const { mutate: getsocialHistory } = useMutation(getSocialHistoryData, {
    onSuccess: (data) => {
      setTableData(data.response),console.log(data.response)
    }
  })
  const [open,setOpen] = useState<boolean>(false)
  const {CustomModal}=usePopup()
  useEffect(() => {
    if (searchData?.pmaster?.id) {
      getsocialHistory(searchData?.pmaster?.id)
    }
  }, [searchData?.pmaster?.id])

  const closepopUp=()=>{
    getsocialHistory(searchData?.pmaster?.id as number)
    setOpen(false)
  }
  return (
    <>

<CustomModal  title='socialHistory' open={open} setOpen={setOpen} handleClose={()=>{closepopUp()}} >

<div className='max-h-[70dvh] w-[60vw]  p-2 overflow-auto' >
  <SocialHistoryData/>
</div>
</CustomModal>

      <div className='flex  justify-between me-5'>
        <Typography className="!ml-2">
          <strong>Social History</strong>
        </Typography>
        <IconButton  onClick={()=>{setOpen(true)}} edge="end" aria-label="delete">
          <EditNoteIcon color='primary' />
        </IconButton>
      </div>
      <Divider />
      <List>
        {
          tableData?.length > 0 ? (tableData?.map((item:any) => {
            return (
              <>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={`${item.description.snomedDescription}-${item.category.name}`}
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'text.primary', display: 'inline' }}
                        >
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            )
          })) :
            <div className="col-span-12 flex justify-center items-center flex-col gap-2">
              <ErrorIcon color="info" sx={{ fontSize: "2rem" }} />
              No Social History found
            </div>
        }

      </List>
    </>
  )
}
export default SocialHistory
